import React from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { useFlexLayout } from 'react-table';
import { CommonConfig } from '../../config/common-config';
import Policy from '../../components/table/policy';
import './style.css';

const useStyles = makeStyles((theme) => ({
    button: {
        margin: '0px 0px 0px 16px !important',
        background: '#4c4fa6 !important',
        color: 'white !important',
        padding: '6px 40px !important',
        // fontFamily: 'Rubik' !important',
        textTransform: 'none !important',
    },
    fontFamilyRubik: {
        fontFamily: 'Rubik !important',
    },
    btnPrivacy: {
        display: 'flex',
        justifyContent: 'flex-start',
    },
    txtJustify: {
        textAlign: 'justify',
    },
}));

export default function TermsConditionBottom({ text, showDialogBoxTerms, callClose, callConfirmation, props }) {
    const dataPolicy = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const setPolicy = dataPolicy && dataPolicy.data.isagreerequired;
    const dataReset = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const setReset = dataReset && dataReset.data.isResetPasswordRequired;
    const dataDetaillsUsername = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const dataDetaills = dataDetaillsUsername && dataDetaillsUsername.data.userName;
    const tennantDetaills = useSelector((state) => state.loginsuccessreducer.tennantName.tennantName);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const history = useHistory();

    const [open, setOpen] = React.useState(false);
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };

    const classes = useStyles();
    const handleAgree = () => {
        const data = {
            userName: dataDetaills,
            tennantName: tennantDetaills,
        };

        axios
            .put(`${CommonConfig.dev.baseUrl}/api/auth/update-eula-policy`, data, axiosConfig)
            .then((response) => {
                if (response.data === 'success') {
                    if (setReset === true) {
                        history.push('/reset');
                    } else {
                        history.push('/menu');
                    }
                }
            })
            .catch((error) => {});
    };
    const handleGoBack = () => {
        history.push('/');
        if (setReset === false && setPolicy === false) {
            history.push('/');
        }
    };

    const handleClose = () => {
        callClose();
    };

    const [maxWidth, setMaxWidth] = React.useState('md');
    const [fullWidth, setFullWidth] = React.useState(true);
    const [showDialogBox, setShowDialogBox] = React.useState(false);
    const handlePolicy = () => {
        setShowDialogBox(true);
    };
    const handlePolicyClose = () => {
        setShowDialogBox(false);
    };
    return (
        <>
            <Dialog
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                open={showDialogBoxTerms}
                onClose={() => handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ fontFamily: 'Rubik' }}
                disableBackdropClick
            >
                <DialogTitle style={{ fontFamily: 'Rubik' }} id="alert-dialog-title">
                    END USER TERMS (“TERMS”)
                </DialogTitle>
                <DialogContent className={classes.txtJustify}>
                    <DialogContentText id="alert-dialog-description" className={classes.fontFamilyRubik} style={{ fontFamily: 'Rubik' }}>
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Advith ITeC Pvt. Ltd. (“Advith ITeC”) is engaged in the business of providing tech enabled business support
                            service relating to financial service requirements of its customers (“Services”) through the software, developed
                            and owned by Advith ITeC under the name and style - “Advith ITeC Platform ”. The Services are provided through
                            the online Website of Advith ITeC – www.advithitec.in (“Website”). The clients of the Customers (“Clients”) and
                            their staff/consultant/employees and the staff/consultant/employees of the Customer including the representative
                            of the Customer accessing the Website are referred to as the “Users” of the Website. The term “Customer” here
                            refers to the customer of Advith ITeC who has entered into a software license cum service agreement with Advith
                            ITeC.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            The Users shall read these Terms carefully before using the Website.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Use includes creation or generation of report, loading or assigning work to Advith ITeC, delivery of work/report
                            required by customer’s clients, loading of report for viewing by customer’s clients, using or viewing the
                            Service. By using any part or whole of the Website, the Users indicate agreement and acceptance to the following
                            terms and conditions and disclaimers as an express agreement between Advith ITeC and the Users. If the User does
                            not understand these terms, conditions, and disclaimers, or does not agree to and accept them, then the User may
                            not use or view any part or whole of the Services.
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className=" fW600">
                            1. Change to Terms
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Advith ITeC reserves the right to change, amend, add, update and modify the Terms at any time without notice.
                            User shall be responsible for regularly reviewing these Terms to obtain timely notice of such changes. User’s
                            continued use of the Website after changes are posted constitutes their acceptance of the amended Terms.
                            Violation of any part of the Terms will result in termination of the User’s account.
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className=" fW600">
                            2. Access
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Users are required to access the Website with the credentials (username & password) as provided by the
                            representative of the Customer.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Users are responsible for all activities on or under their user account and Users accept all risks for any
                            unauthorized use of their account.
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className=" fW600">
                            3. Access Grant and Restrictions
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            The software underlying the Services is owned by Advith ITeC. Advith ITeC confers no title or ownership in the
                            software. Subject to the terms and conditions of these Terms, Advith ITeC grants the Users a non-exclusive and
                            non-transferable right to:
                            <ol type="a">
                                <li>
                                    access the features and functions of the Services solely for the Users’ access to Services during the
                                    term; and
                                </li>

                                <li>
                                    {' '}
                                    view, download, reproduce, and print the report made available to the Users through the Services. Advith
                                    ITeC may suspend access for any User who violates these Terms, provided that such violation is not cured
                                    within two (2) days of the User receiving written notice thereof. The User’s access to the Services will
                                    be suspended during the said cure period of two (2) days.
                                </li>
                            </ol>
                        </Typography>
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            User agrees that the User will not:
                            <ol type="a">
                                <li>
                                    Permit any third party to access and/or use the Service, other than the Users authorized under these
                                    Terms;{' '}
                                </li>
                                <li>Rent, lease, loan, or sell access to the Services to any third party;</li>
                                <li>
                                    Interfere with, disrupt, alter, translate, or modify the Services or any part thereof, or create an
                                    undue burden on the Services or the networks or services connected to the Service{' '}
                                </li>
                                <li>
                                    {' '}
                                    Reverse engineer, decompile, disassemble or otherwise attempt to obtain or perceive the source code from
                                    which any software component of the Services are compiled or interpreted, and Users acknowledge that
                                    nothing in these Terms will be construed to grant Users any right to obtain or use such code;
                                </li>{' '}
                                <li>
                                    Access the Services in order to build or create a derivative, competitive or similar product or service
                                    or copy any ideas, features, functions or graphics of the Services; or{' '}
                                </li>
                                <li>
                                    Introduce software or automated agents or scripts to the Services so as to produce multiple accounts,
                                    generate automated searches, requests and queries, or to strip or mine data from the Services.
                                </li>
                            </ol>
                        </Typography>
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Users agree not to attempt to access any of the Services by any means other than through the interface that is
                            provided by Advith ITeC nor to engage in any activity that interferes with or disrupts the Services or infringes
                            on Advith ITeC’s and/or its third party vendors’ brand or intellectual property. Users will use the Services in
                            conformance with all applicable laws. In addition, Users agree not to use, or encourage or permit others to use,
                            the Services to:
                            <ol type="a">
                                <li>Stalk and/or harass another;</li> <li> Harm minors in any way;</li>{' '}
                                <li>
                                    Impersonate any person or entity, or falsely state or otherwise misrepresent User’s affiliation with a
                                    person or entity;{' '}
                                </li>
                                <li>
                                    Forge headers or otherwise manipulate identifiers to disguise the origin of any content posted on or
                                    transmitted through the Service;{' '}
                                </li>
                                <li>
                                    Use the Services or content such that it will mislead a third party into believing that he or she is
                                    interacting directly with Advith ITeC or the Service;{' '}
                                </li>
                                <li>
                                    {' '}
                                    Engage in any chain letters, contests, junk email, pyramid schemes, spamming, surveys or other
                                    duplicative or unsolicited messages (commercial or otherwise);
                                </li>{' '}
                                <li>
                                    {' '}
                                    Access or use the Services in any manner that could damage, disable, overburden or impair any Advith
                                    ITeC’s server or the networks connected to any of Advith ITeC’s server;
                                </li>{' '}
                                <li>
                                    Harvest, collect, gather or assemble information or data regarding other users without their consent.
                                </li>
                            </ol>
                        </Typography>
                        <Typography variant="subtitle1" className=" fW600">
                            4. Use by Minors
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            The Website shall not be used by minors. The Website is directed only to individuals who are permitted to
                            legally enter into contracts in India and those who do not require consent from their natural/legal guardian to
                            do so. Advith ITeC has hereby cautioned all Users of the same. However, if the Website is used by minors
                            irrespective of such caution by Advith ITeC, then Advith ITeC shall not be responsible for any claims from any
                            authorities/third parties regarding the same.
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className=" fW600">
                            5. Prohibited Activities
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Users shall not in any way use the Website or submit to the Website anything which in any respect is:
                            <ol>
                                <li>In breach of any law in India,</li>
                                <li>Fraudulent, criminal or unlawful,</li>
                                <li>Inaccurate or out-of-date,</li>
                                <li>
                                    Obscene, indecent, harassing, libelous, abusive, vulgar, profane, racist, discriminatory, offensive,
                                    harmful, harassing, threatening, embarrassing, malicious, abusive, hateful, defamatory, untrue or
                                    political, or otherwise unlawful,{' '}
                                </li>
                                <li>Impersonates any other person or misrepresents a relationship with any person,</li>
                                <li>
                                    Transmitting material that encourages conduct that constitutes a criminal offence or results in civil
                                    liability or otherwise breaches any relevant laws, regulations or code of practice,
                                </li>
                                <li>Gaining unauthorized access to other computer systems,</li>
                                <li> Interfering or disrupting networks or websites connected to the Website.</li>
                                <li>
                                    An infringement or breach of the intellectual property rights or privacy or other rights of Advith ITeC
                                    or any third party,
                                </li>
                                <li>
                                    Making, transmitting or storing electronic copies of materials protected by copyright without the
                                    permission of the owner,
                                </li>
                                <li>Contrary to the interests of Advith ITeC, or</li>
                                <li>
                                    Contrary to any specific rule or requirement that Advith ITeC stipulates on the Website in relation to a
                                    particular part of the Website or the Website in general.
                                </li>
                            </ol>
                        </Typography>
                        <Typography variant="subtitle1" className=" fW600">
                            6. Customer Data
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Users grant Advith ITeC a non-exclusive, worldwide, royalty-free and fully paid license to use, copy, and
                            display the Customer Data solely for the purpose of and to the extent necessary to provide the Services
                            hereunder to the Users (“Customer Data”).
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            "Customer Data" means data, information or material provided or submitted by Customer or any User to the Website
                            in the course of utilizing the Service including but not limited to the information relating to the Clients.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Users grant Advith ITeC non-exclusive, worldwide, royalty-free and fully paid license to use Users’ trademarks,
                            service marks, and logos to provide the Services to the Users.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Users shall be responsible for and assumes the risk, responsibility and expense of:
                            <ol type="a">
                                <li>
                                    {' '}
                                    Any problems resulting from, the accuracy, quality, integrity, legality, reliability, and
                                    appropriateness of all such Customer Data;
                                </li>
                                <li>
                                    Customer Data violating or infringing any third party’s rights including, but not limited to, privacy,
                                    publicity or intellectual property rights.
                                </li>
                            </ol>
                        </Typography>
                        <Typography variant="subtitle1" className=" fW600">
                            7. Users’ Responsibility for their Customer Data
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Notwithstanding anything to the contrary herein, Users are responsible for all Customer Data they create, make
                            available or post to the Services, and Advith ITeC does not assume any responsibility thereof. The Customer Data
                            shall be in English, shall be legally sound and not violate any laws in force. Users may expose themselves to
                            liability if, for example and without limitation, their Customer Data contains material that is:
                            <ol type="i">
                                <li> False, intentionally misleading, or defamatory;</li>
                                <li> Violates any third-party right;</li>
                                <li> Contains material that is unlawful, including illegal hate speech or pornography;</li>{' '}
                                <li>Exploits or otherwise harms minors; or </li>
                                <li>
                                    Violates or advocates the violation of any law or regulation. Accordingly, the Users agree that any and
                                    all Customer Data shall comply with these Terms and any policies and guidelines that may be posted by
                                    Advith ITeC from time to time. It is expressly made clear that the Users submitting the information of
                                    the Clients, for the purpose of providing Services, shall have obtained the prior consent of the Client
                                    for such submission/disclosure to Advith ITeC and/or for uploading on the Website for the purpose of
                                    providing the Services. It shall be the sole responsibility of the Users to conform with this
                                    requirement of law and shall keep and hold Advith ITeC indemnified against any claim/damages/suit
                                    initiated or brought by the Clients against Advith ITeC for violation of their privacy.
                                </li>
                            </ol>
                        </Typography>
                        <Typography variant="subtitle1" className=" fW600">
                            8. Damaging the Website
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Users agree not to access without authority, interfere with, damage or disrupt:
                            <ol>
                                <li>Any part of the Website,</li>
                                <li>Any equipment or network on which the Website is stored,</li>
                                <li>Any software used in the provision of the Website, or </li>
                                <li>Any equipment or network or software owned or used by any third party.</li>
                            </ol>
                        </Typography>
                        <Typography variant="subtitle1" className=" fW600">
                            9. Confidentiality
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Each party agrees to:
                            <ol type="a">
                                <li>
                                    {' '}
                                    Use the Confidential Information of the other party only for the purposes described and as permitted
                                    herein; and{' '}
                                </li>
                                <li>
                                    Restrict access to the Confidential Information to such of its personnel, agents, and/or consultants, if
                                    any, who have a need to have access and who have been advised of and have agreed in writing or are
                                    otherwise bound to treat such information in accordance with these Terms. The foregoing provision will
                                    not apply to Confidential Information that
                                </li>
                            </ol>
                            <ol type="a">
                                <li>Is or has become publicly known other than through breach of this Term; or</li>
                                <li> Was in the possession of the receiving Party prior to disclosure by the other party; or </li>
                                <li>
                                    Was received by the receiving Party from an independent third party who is not subject to an obligation
                                    of confidentiality to the disclosing Party; or
                                </li>
                                <li>
                                    {' '}
                                    was independently developed by the receiving party; Notwithstanding the foregoing, each party may
                                    disclose Confidential Information to the limited extent required
                                </li>
                            </ol>
                            <ol type="1">
                                <li>
                                    In order to comply with the order of a court or other governmental body, or as otherwise necessary to
                                    comply with applicable law, provided that the party making the disclosure pursuant to the order will
                                    first have given written notice to the other party and made a reasonable effort to obtain a protective
                                    order; or{' '}
                                </li>
                                <li>
                                    To establish a party’s rights under this Agreement, including to make such court filings as it may be
                                    required to do.
                                </li>
                            </ol>
                        </Typography>
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            “Confidential Information” for the purpose of these Terms means any non-public material or information relating
                            to a party including any details, documents, financial quotes, invoices, information, know-how etc., which it
                            discloses or makes available to the other party under these Terms that such disclosing party treats as
                            proprietary or confidential, unless otherwise set forth herein.
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className=" fW600">
                            10. Privacy
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            The personally identifiable information disclosed by Users shall be subject to privacy policy of Advith ITeC
                            accessible at{' '}
                            <span className="hyperLinkCss" onClick={handlePolicy}>
                                Privacy Policy
                            </span>
                            .
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className=" fW600">
                            11. Users Agree and Confirm
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            That the Users will use the services provided by Advith ITeC, for lawful purposes only and comply with all
                            applicable laws and regulations while using and transacting on the Website
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            The User will provide authentic and true information in all instances where such information is requested of the
                            User. Advith ITeC reserves the right to confirm and validate the information and other details provided by the
                            User at any point of time. If upon confirmation, the Users’ details are found not to be true (wholly or partly),
                            Advith ITeC has the right in its sole discretion to reject the registration and debar the User from using the
                            Services on the Website and / or other affiliated websites without prior intimation whatsoever.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            That the Users are accessing the Services available on this Website and transacting at the Users’ sole risk and
                            are using their best and prudent judgment before entering into any transaction through this Website.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            The fee for the Services shall be agreed between the Customer and its Clients and the same shall vary depending
                            on the scope of work and arrangement between the Customer and its Clients. It is hereby clarified that
                            considering the business module, Advith ITeC has no policy of refund or cancellation. However, if there is any
                            refund or cancellation claimed by any Customer and its Clients, the same shall be made as per the agreed terms
                            between Advith ITeC and the Customer and its Clients.
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className=" fW600">
                            12. Limitation of Liability
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Advith ITeC shall not be liable for any claims, demands and damages of any kind arising from the Users’ use of
                            or inability to use the Website. Advith ITeC shall not be responsible for any claims, demands and damages of any
                            kind arising out of or in any way connected with any disputes arising between the Users and third parties or
                            among different Users.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Users assume all responsibility and risk with respect to their use of the Website. Users agree and understand
                            that, to the fullest extent permitted by law, Advith ITeC disclaims all warranties, representations and
                            endorsements either express or implied with regard to the Website. If information provided by Users is
                            misleading or incorrect, Advith ITeC shall not be liable for the same and there shall be no such claims against
                            Advith ITeC in the said regard.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Users agree not to reproduce, duplicate, copy or re-sell the Website or any part thereof except as may be
                            permitted by these Terms. Any such unauthorized use of the Website by the Users will make them liable to pay
                            Advith ITeC damages.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            In no event shall Advith ITeC be liable to Users for any consequential, special, incidental or indirect damages
                            of any kind arising out of the performance or use of the services, even if Advith ITeC has been advised of the
                            possibility of such damages.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            In case of force majeure beyond the control of Advith ITeC such as the Website, or any software related to that,
                            being hacked by third parties, network issues, etc., Advith ITeC shall not be held responsible for any claims
                            from Users.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Advith ITeC shall not be responsible in the event of any third party claim that the Website or the possession
                            and use of the Website by any User infringes such third party’s intellectual property rights.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            User represents and warrants that the use of the Website will strictly be in accordance with these Terms and
                            with all applicable laws in India regarding online conduct. Advith ITeC shall not be held responsible for the
                            same. User further agrees that this is a binding agreement between Advith ITeC and User and that User is legally
                            competent to accept these Terms, as per laws of India.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            ADVITH ITeC PROVIDES NO WARRANTY OR REPRESENTATION, EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION, THOSE OF
                            MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE. THE SERVICE AND THE UNDERLYING SOFTWARE ARE PROVIDED TO
                            USER ON AN "AS IS" AND "AS AVAILABLE" BASIS. USER ASSUMES ALL RESPONSIBILITY FOR DETERMINING WHETH¬ER THE
                            SERVICE OR THE INFORMATION GENERATED THEREBY IS ACCURATE OR SUFFICIENT FOR USER'S PURPOSES. ADVITH ITeC DOES NOT
                            WARRANT THAT USE OF THE SERVICE WILL BE ERROR-FREE OR UNINTERRUPTED. ADVITH ITeC IS NOT RESPON¬SIBLE FOR
                            SOFTWARE INSTALLED OR USED BY CUSTOMER OR USERS OR FOR THE OPERATION OR PERFORMANCE OF THE INTERNET.
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className=" fW600">
                            13. Indemnification
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            User agrees to indemnify Advith ITeC against any and all losses, expenses, damages and costs resulting from the
                            use of the Website not in accordance with these Terms and/or any violation of these Terms or the applicable
                            laws. Advith ITeC has the right to assume the exclusive defense and control of any demand, claim or action
                            arising herein or in connection with the Website and all negotiations for settlement or compromise. User agrees
                            to fully cooperate with Advith ITeC in the defense of any such negotiations as requested by Advith ITeC.
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className=" fW600">
                            14. Intellectual Property Rights
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Advith ITeC retains all right, title and interest, including without limitation to the intellectual property
                            rights upon and relating to the Website, including but not limited to, all software, technology, documents,
                            products, logos, graphic, sounds, images, information, content materials, guidelines and documentation. User
                            will not acquire any title, right or interest therein, except for the limited use rights expressly set forth in
                            these Terms. Any rights that Advith ITeC does not expressly grant herein are deemed withheld. It is clearly and
                            well understood by and between the parties that Advith ITeC is in no way transferring or assigning its
                            proprietary rights of the Website to User or any other party and it shall remain the exclusive property of
                            Advith ITeC. Advith ITeC reserves the right, at its sole discretion, to modify, change, update and/or enhance
                            the Website. Advith ITeC also reserves the right, in its sole discretion and at any time, to terminate the
                            Users’ access to the Website and/or any of its services without liability to the Users or any third party.
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className=" fW600">
                            15. Third Party Websites
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            User must comply with any applicable third party terms of agreement when using the Website. Advith ITeC has no
                            control over and accepts no responsibility for the content of any third party links from the Website. The linked
                            websites or mobile applications are provided for the User’s convenience without any warranty, express or
                            implied, for the information provided within them. Advith ITeC does not provide any endorsement or
                            recommendation of any link of a third party website or mobile application. The terms and conditions, terms of
                            use and privacy policies of those third party website or mobile applications will apply to User. Advith ITeC
                            shall not be liable for any queries, concerns or complaints about such third party website or mobile
                            applications. It is the Users’ responsibility to take precautions to ensure that whatever is selected for use is
                            free of viruses or other items of a destructive nature.
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className=" fW600">
                            16. Severability
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            In the event of invalidity of any provision of these Terms, the parties agree that such invalidity shall not
                            affect the validity of the remaining portions of these Terms.
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className=" fW600">
                            17. Termination
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            This service will terminate automatically, without notice from Advith ITeC, if the User fails to comply with the
                            Terms. Upon termination, the User shall immediately discontinue use of the Services and destroy all copies of
                            the Services.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Not with standing termination, the following provisions shall survive: Users Agree and confirm clause, Users’
                            responsibility for their Customer Data, Users’ Indemnification, Confidentiality and Limitation of Liability. All
                            other rights granted under this service will cease upon termination.
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className=" fW600">
                            18. Waiver
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            The failure of either party to insist upon a strict performance of any of the terms or provisions herein or to
                            exercise option, right or remedy herein contained, shall not in future be construed as waiver or a
                            relinquishment of such terms, provisions, option, right or remedy, but the same shall continue and remain in
                            full force and effect. No waiver by either party of any term or provision hereof shall be deemed to have been
                            made unless expressed in writing and signed by such Party.
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className=" fW600">
                            19. Governing Law, Dispute Settlement and Jurisdiction
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            These Terms shall be construed in accordance with the applicable laws of India. The Courts at Bangalore shall
                            have exclusive jurisdiction in any proceedings arising out of these Terms. In the event of any dispute or
                            difference either in interpretation or otherwise, of any terms of this Terms between the parties hereto, the
                            same shall be referred to an independent arbitrator who will be appointed by Advith ITeC and his decision shall
                            be final and binding on the parties hereto. The above arbitration shall be in accordance with the Arbitration
                            and Conciliation Act, 1996 as amended from time to time. The arbitration shall be held in Bangalore - Karnataka.
                            The Courts at Bangalore - Karnataka alone shall have the jurisdiction and the Laws of India shall apply.
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className=" fW600">
                            20. Miscellaneous
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            This Terms (and the Privacy Policy of Advith ITeC along with any other terms and conditions specified by Advith
                            ITeC, such as those sent via email, etc.) contains all the terms agreed between the parties regarding the
                            Website, Service and its use and supersedes and excludes any prior terms and conditions between the parties save
                            and except any written agreement entered into between the parties, which shall prevail over these Terms in case
                            of conflict.
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.btnPrivacy}>
                    <Button onClick={handleGoBack} variant="outlined" color="primary" size="small" className={classes.button}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            {showDialogBox && (
                <Policy
                    showDialogBox={showDialogBox}
                    // updateCRCRelevance={updateCRCRelevance}
                    handlePolicyClose={handlePolicyClose}
                    // relevanceindex={relevanceindex}
                    // crcCategory={category}
                    // crcRemarks={remarks}
                />
            )}
        </>
    );
}
